<template>
  <div class="privacy-container">
    <div class="privacy-text-container">
      <div>
        <p class="c18 c23"><span class="c1"></span></p>
      </div>
      <p class="c12 c29">
        <span class="c7 c3 c25">Impostors Platform Terms Of Service</span>
      </p>
      <p class="c12 c15">
        <span class="c6 c2">Effective Date:&nbsp;March 24, 2022</span>
      </p>
      <p class="c30" id="h.3znysh7">
        <span class="c2"
          >Please read these Impostors Platform Terms of Service (these “</span
        ><span class="c2 c3">Terms</span
        ><span class="c2">”) and our Privacy Policy </span><span>&nbsp;</span
        ><span class="c14 c2"
          ><a class="c10" href="https://impostors.gg/privacy"
            >https://impostors.gg/privacy</a
          ></span
        ><span class="c2"> (“</span><span class="c2 c3">Privacy Policy</span
        ><span class="c2"
          >”) carefully because they govern your access to and use of the
          website and interface located at </span
        ><span class="c14"
          ><a
            class="c10"
            href="https://urldefense.com/v3/__https:/impostors.gg/__;!!HJT62s_lzg!lSwmclyfF5Tg-63b0kOTiYDDk3NkxhLKb0EncPdH1GVfWjiOV8VpjjdSx0okbOzAjA$"
            >https://impostors.gg/</a
          ></span
        ><span class="c2">&nbsp;(the “</span><span class="c2 c3">Site</span
        ><span class="c2">”) and corresponding mobile application (“</span
        ><span class="c2 c3">App</span
        ><span class="c2"
          >”) offered by Super Studios, Inc., a Delaware corporation (“</span
        ><span class="c2 c3">Super</span><span class="c2">&nbsp;</span
        ><span class="c2 c3">Studios</span><span class="c2">,” “</span
        ><span class="c2 c3">we</span><span class="c2">,” “</span
        ><span class="c2 c3">us</span><span class="c2">” or “</span
        ><span class="c2 c3">our</span
        ><span class="c2"
          >”), including without limitation: the purchase of certain digital
          assets in the form of non-fungible cryptocurrency tokens (“</span
        ><span class="c2 c3">NFTs</span
        ><span class="c2"
          >”) on the decentralized blockchains on which the NFTs are recorded
          (“</span
        ><span class="c2 c3">Blockchain</span
        ><span class="c2"
          >”), as well as the access to the Impostors interactive entertainment
          application (the “</span
        ><span class="c2 c3">Impostors Game</span
        ><span class="c2"
          >”), and our online services and software provided on or in connection
          with those services that are accessible via the Site and the App. To
          make these Terms easier to read, the Site, the App and the
          aforementioned services are collectively called the “</span
        ><span class="c2 c3">Services.</span
        ><span class="c6 c2"
          >” &nbsp;For clarity, the Services, the Site and the App do not
          include the SuperFarm smart contract, $SUPER tokens, $BLOOD tokens or
          any other aspect of the Ethereum or other blockchain-based network
          with which the Site, App and Services interact. &nbsp;</span
        >
      </p>
      <p class="c30" id="h.gjdgxs">
        <span class="c2 c3 c12"
          >IMPORTANT NOTICE REGARDING ARBITRATION: WHEN YOU AGREE TO THESE TERMS
          YOU ARE AGREEING (WITH LIMITED EXCEPTION) TO RESOLVE ANY DISPUTE
          BETWEEN YOU AND SUPER STUDIOS THROUGH BINDING, INDIVIDUAL ARBITRATION
          RATHER THAN IN COURT. PLEASE REVIEW CAREFULLY SECTION 17 “DISPUTE
          RESOLUTION; ARBITRATION” BELOW FOR DETAILS REGARDING ARBITRATION. </span
        ><span class="c7 c2 c3"
          >HOWEVER, IF YOU ARE A RESIDENT OF A JURISDICTION WHERE APPLICABLE LAW
          PROHIBITS ARBITRATION OF DISPUTES, THE AGREEMENT TO ARBITRATE IN
          SECTION 17 WILL NOT APPLY TO YOU BUT THE PROVISIONS OF SECTION 18
          “GOVERNING LAW AND VENUE” WILL APPLY INSTEAD.</span
        >
      </p>
      <ol class="c4 lst-kix_list_1-0 start" start="1">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Agreement to Terms</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >By using our Services, you agree to be bound by these Terms.
              &nbsp;If you do not agree to be bound by these Terms, you may not
              use the Services.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Super Studios reserves the right to change or modify these Terms
              at any time and in our sole discretion. If we make changes to
              these Terms, we will provide notice of such changes, such as by
              sending an email notification, providing notice through the
              Services or updating the “Effective Date” date at the beginning of
              these Terms. Those additional terms and conditions, which are
              available with the relevant services, then become part of your
              agreement with us if you use those services. By continuing to
              access or use the Services, you confirm your acceptance of the
              revised Terms and all of the terms and conditions incorporated
              therein by reference. We encourage you to review the Terms
              frequently to ensure that you understand the terms and conditions
              that apply when you access or use the Services. If you do not
              agree to the revised Terms, you may not access or use the
              Services.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >BY USING OUR SERVICES, ACCESSING THE IMPOSTORS GAME AND/OR
              PURCHASING CRYPTOCURRENCY ASSETS THROUGH THE SERVICES, YOU AGREE
              TO BE BOUND BY THESE TERMS AND ALL OF THE TERMS AND CONDITIONS
              INCORPORATED HEREIN BY REFERENCE.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="2">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Privacy Policy</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Please refer to our Privacy Policy, which also governs your use
              of the Services, for information about how we collect, use and
              share information about you.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="3">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c7 c2 c3">Who May Use the Services?</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Eligibility</span
            ><span class="c6 c2"
              >. You may use the Services only if you are 16 years or older and
              capable of forming a binding contract with Super Studios, and not
              otherwise barred from using the Services under applicable
              law.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Compliance</span
            ><span class="c6 c2"
              >. &nbsp;The Services are only available to users in certain
              jurisdictions who can use the Services as permitted under
              applicable law. You certify that you will comply with all
              applicable laws (e.g., local, state, federal and other laws) when
              using the Services. Without limiting the foregoing, by using the
              Services, you represent and warrant that: (a) you are not located
              in a country that is subject to a U.S. Government embargo; and (b)
              you are not listed on any U.S. Government list of prohibited,
              sanctioned, or restricted parties. If you access or use the
              Services outside the United States, you are solely responsible for
              ensuring that your access and use of the Services in such country,
              territory or jurisdiction does not violate any applicable laws.
              You must not use any software or networking techniques, including
              use of a Virtual Private Network (VPN) to modify your internet
              protocol address or otherwise circumvent or attempt to circumvent
              this prohibition. We reserve the right, but have no obligation, to
              monitor where our Services are accessed from. Furthermore, we
              reserve the right, at any time, in our sole discretion, to block
              access to the Services, in whole or in part, from any geographic
              location, IP addresses and unique device identifiers or to any
              user who we believe is in breach of these Terms.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="4">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3"
              >About the Services; Limitations and Relationship Between the
              Parties</span
            ><span class="c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">The Impostors Platform</span
            ><span class="c2"
              >. The Services include the ability to access the platform,
              through the Site and the App, which facilitates interactions with
              certain decentralized cryptographic protocols and Blockchains to
              allow individuals to purchase NFTs and access the Impostors Game
              (the “</span
            ><span class="c2 c3">Impostors Platform</span
            ><span class="c6 c2">”). </span>
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-2 start" start="1">
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >You may participate in the Services by linking your digital
              wallet on supported bridge extensions, which allows you to
              purchase, store, and engage in transactions using certain
              cryptocurrencies. Before purchasing a unique digital asset or
              accessing the Impostors Game, we will ask you to download a
              supported electronic wallet extension and connect and unlock your
              digital wallets with that extension. Once you submit an order to
              purchase a unique digital asset, your order is passed on to the
              applicable extension, which completes the transaction on your
              behalf.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >WE ARE NOT A BROKER, FINANCIAL INSTITUTION, OR CREDITOR. THE
              SERVICES ARE OFFERED THROUGH AN ADMINISTRATIVE PLATFORM ONLY.
              SUPER STUDIOS FACILITATES TRANSACTIONS BETWEEN A BUYER AND SELLER
              BUT IS NOT A PARTY TO ANY AGREEMENT BETWEEN THE BUYER AND SELLER
              OF NFTS OR BETWEEN ANY USERS.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >YOU BEAR FULL RESPONSIBILITY FOR VERIFYING THE IDENTITY,
              LEGITIMACY, AND AUTHENTICITY OF ASSETS YOU PURCHASE ON THE
              IMPOSTORS PLATFORM. NOTWITHSTANDING INDICATORS AND MESSAGES THAT
              SUGGEST VERIFICATION, SUPER STUDIOS MAKES NO CLAIMS ABOUT THE
              IDENTITY, LEGITIMACY, OR AUTHENTICITY OF ASSETS ON THE
              PLATFORM.</span
            >
          </h3>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1" start="2">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3"
              >Transactions Are Conducted on the Blockchain</span
            ><span class="c6 c2"
              >. While Super Studios offers a platform for users to purchase
              NFTs and access the Impostors Game, it does not buy, sell, or take
              custody or possession of any NFTs, nor does it act as an agent or
              custodian for any user of the Services. You acknowledge that Super
              Studios does not take control or custody of any NFT or
              cryptocurrency at any time. If you elect to purchase any NFTs, any
              financial transactions that you engage in will be conducted solely
              through the blockchain network governing such NFT, and you will be
              required to make or receive payments exclusively through the
              cryptocurrency wallet you have connected to the Site. We will have
              no insight into or control over these payments or transactions,
              nor do we have the ability to reverse any transactions.
              Accordingly, we will have no liability to you or to any third
              party for any claims or damages that may arise as a result of any
              transactions that you engage in via the Services. There may be
              royalties associated with the secondary sale of any NFT. You
              acknowledge and agree that the payment of any such royalty shall,
              in certain circumstances, be programmed to be self-executing via a
              blockchain network’s nonfungible token standard, and Super Studios
              does not have any control or ability to direct such funds or the
              obligation to collect such fees. Every transaction on the
              Impostors Platform is subject to fees collected to support the NFT
              creators and Impostors Platform as posted on the Site or otherwise
              set forth in these Terms.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Terms Applicable to Purchasers</span
            ><span class="c2"
              >. If you are using the Services to purchase NFTs, you are a
              “</span
            ><span class="c2 c3">Purchaser</span
            ><span class="c6 c2"
              >,” and you agree to the following additional terms:
            </span>
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-2 start" start="1">
        <li class="c8">
          <h3 style="display: inline">
            <span class="c2 c3">Purchase Terms</span
            ><span class="c2"
              >. &nbsp;Any NFT that you purchase is governed entirely by the
              smart contract and the blockchain network governing such NFT.
              &nbsp;NFTs may be subject to additional terms directly between
              Purchasers and the seller of such NFTs (the “</span
            ><span class="c2 c3">Seller</span
            ><span class="c2"
              >”), namely: (i) in any associated smart contract or metadata or
              (ii) as Purchasers and Seller may agree otherwise (e.g., with
              respect to terms or benefits associated with a given NFT) ((i) and
              (ii), collectively, “</span
            ><span class="c2 c3">Purchase Terms</span
            ><span class="c2"
              >”). &nbsp;Super Studios is not a party to any Purchase Terms,
              which are solely between the Purchaser and the Seller. &nbsp;The
              Purchaser and Seller are entirely responsible for communicating,
              promulgating, agreeing to, and enforcing Purchase Terms.
              &nbsp;Seller must comply with and fulfill the Purchase Terms with
              respect to any NFTs that it sells. &nbsp;When you purchase an NFT
              through the Services, you own all personal property rights to that
              NFT (i.e., the right to sell or otherwise dispose of that NFT).
              &nbsp;Such rights, however, do not include the ownership of the
              intellectual property rights in any digital art embodied in the
              NFTs and any name, logos, trademarks, likeness, image, signature,
              voice and other identifiable characteristics included in the
              digital art embodied in the NFTs (collectively, the “</span
            ><span class="c2 c3">NFT Content</span
            ><span class="c6 c2"
              >”). Rather, unless specified otherwise in Purchase Terms, the
              Purchaser will have a worldwide, non-exclusive, non-transferable,
              royalty-free license to use, copy, and display the NFT Content
              associated with its purchased NFT), solely for the following
              purposes: (i) for your own personal, non-commercial use; (ii)
              attempts to sell or otherwise dispose of the NFT consistent with
              the ownership of it; and (iii) as part of a third party offering
              compatible with the purchased NFT in the normal course of the
              permitted end-use of such offering.
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 id="h.30j0zll" style="display: inline">
            <span class="c2 c3">Costs and Fees</span
            ><span class="c2"
              >. &nbsp;Transactions on the Impostors Platform may be subject to
              fees that Super Studios collects to support the Services, as
              posted on the Site or otherwise set forth in these Terms. “</span
            ><span class="c2 c3">Revenue</span
            ><span class="c2"
              >” means the purchase price paid by the Purchaser for your NFT on
              the Impostors Platform. &nbsp;Revenue does not include any Taxes
              (defined below) or transaction fees. &nbsp;You further agree to
              pay all other applicable fees, including Gas Fees and hosting
              fees, and you authorize Super Studios to automatically charge you
              for any such fees or deduct such fees directly from your amounts
              paid by the Purchaser. &nbsp;</span
            ><span class="c2 c17"
              >The payments made do not include any Taxes (as defined below),
              and Super Studios shall have no responsibility for payment of such
              Taxes regardless of the taxing authority. &nbsp;Each party shall
              be responsible for all Taxes imposed on its income or
              property.</span
            ><span class="c2"
              >&nbsp;Purchasers will be responsible for paying all such fees.
              &nbsp;In addition, interactions with the Blockchain may also
              result in transaction fees or Gas Fees (as defined below) imposed
              by the Blockchain, which are also solely your responsibility.
              “</span
            ><span class="c2 c3">Gas fees</span
            ><span class="c6 c2"
              >” mean the fees that fund the network of computers that run the
              decentralized blockchain network, meaning that you will need to
              pay a Gas Fee for each transaction that occurs via the blockchain
              network.</span
            >
          </h3>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1" start="4">
        <li class="c24">
          <span class="c2 c3 c7"
            >Terms Applicable to Users Accessing the Impostors Game</span
          ><span class="c6 c2">.</span><span class="c7 c2 c3">&nbsp;</span
          ><span class="c6 c2"
            >If you are using the Services to access the Impostors Game, you are
            a “</span
          ><span class="c7 c2 c3">Gamer</span
          ><span class="c6 c2"
            >,” and you agree to be bound by and comply with the Impostors Game
            End User License Agreement (the “</span
          ><span class="c7 c2 c3">EULA</span
          ><span class="c6 c2"
            >”) and Purchase Terms, as applicable. Super Studios is not a party
            to the EULA or the Purchase Terms, which are solely between the
            Gamer and the Impostors Foundation and Impostors Protocol Ltd., the
            subsidiary of the Impostors Foundation, respectively. &nbsp;The
            Gamer and the Impostors Foundation are entirely responsible for
            communicating, promulgating, agreeing to, and enforcing the EULA.
            The Gamer and Impostors Protocol Ltd. are entirely responsible for
            communicating, promulgating, agreeing to, and enforcing the Purchase
            Terms.</span
          >
        </li>
        <li class="c5">
          <h2 id="h.1fob9te" style="display: inline">
            <span class="c2 c3">Taxes</span
            ><span class="c2"
              >. You are solely responsible for all costs incurred by you in
              using the Services and determining, collecting, reporting and
              paying all applicable Taxes. &nbsp;As used herein, “</span
            ><span class="c2 c3">Taxes</span
            ><span class="c6 c2"
              >” means the taxes, duties, levies, tariffs, and other
              governmental charges that you may be required by law to collect
              and remit to governmental agencies, and other similar municipal,
              state, federal and national indirect or other withholding and
              personal or corporate income taxes. &nbsp;You are solely
              responsible for maintaining all relevant Tax records and complying
              with any reporting requirements you may have as related to our
              Services. You are further solely responsible for independently
              maintaining the accuracy of any record submitted to any tax
              authority including any information derived from the Services. We
              reserve the right to report any activity occurring using the
              Services to relevant tax authorities as required under applicable
              law.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Suspension or Termination</span
            ><span class="c2"
              >. &nbsp;We may suspend or terminate your access to the Services
              at any time in connection with any transaction as required by
              applicable law, any governmental authority, or if we in our sole
              and reasonable discretion determine you are violating these Terms
              or the terms of any third-party service provider. &nbsp;Such
              suspension or termination shall not be constituted a breach of
              these Terms by Super Studios. In accordance with its anti-money
              laundering, anti-terrorism, anti-fraud, and other compliance
              policies and practices, we may impose reasonable limitations and
              controls on the ability of you or any beneficiary to utilize the
              Services. &nbsp;Such limitations may include where good cause
              exists, rejecting transaction requests, freezing funds, or
              otherwise restricting you from using the Services.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="5">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Feedback</span><span class="c6 c2">. </span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c24">
          <span class="c6 c2"
            >We appreciate feedback, comments, ideas, proposals and suggestions
            for improvements to the Services (“</span
          ><span class="c7 c2 c3">Feedback</span
          ><span class="c6 c2"
            >”). If you choose to submit Feedback, you agree that we are free to
            use it without any restriction or compensation to you.</span
          >
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="6">
        <li class="c26 c28">
          <span class="c7 c2 c3">Rights and Terms for Apps.</span>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 id="h.2et92p0" style="display: inline">
            <span class="c2 c3 c16">App License</span
            ><span class="c2 c16 c20"
              >. If you comply with these Terms, Super Studios grants to you a
              limited non-exclusive, non-transferable license, with no right to
              sublicense, to download and install the App on your personal
              computers, mobile handsets, tablets, wearable devices, and/or
              other devices and to run the App solely for your own personal
              non-commercial purposes. Except as expressly permitted in these
              Terms, you may not: (i)&nbsp;copy, modify or create derivative
              works based on the App; (ii)&nbsp;distribute, transfer,
              sublicense, lease, lend or rent the App to any third party;
              (iii)&nbsp;reverse engineer, decompile or disassemble the App
              (unless applicable law permits, despite this limitation); or
              (iv)&nbsp;make the functionality of the App available to multiple
              users through any means.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 id="h.tyjcwt" style="display: inline">
            <span class="c2 c16 c3"
              >Additional Information: Apple App Store</span
            ><span class="c2 c20 c16"
              >. This Section 6(b) applies to any App that you acquire from the
              Apple App Store or use on an iOS device. Apple has no obligation
              to furnish any maintenance and support services with respect to
              the App. In the event of any failure of the App to conform to any
              applicable warranty, you may notify Apple, and Apple will refund
              the App purchase price to you (if applicable) and, to the maximum
              extent permitted by applicable law, Apple will have no other
              warranty obligation whatsoever with respect to the App. Apple is
              not responsible for addressing any claims by you or any third
              party relating to the App or your possession and use of it,
              including, but not limited to: (i) product liability claims; (ii)
              any claim that the App fails to conform to any applicable legal or
              regulatory requirement; and (iii) claims arising under consumer
              protection or similar legislation. Apple is not responsible for
              the investigation, defense, settlement and discharge of any
              third-party claim that your possession and use of the App infringe
              that third party’s intellectual property rights. Apple and its
              subsidiaries are third-party beneficiaries of these Terms, and
              upon your acceptance of the Terms, Apple will have the right (and
              will be deemed to have accepted the right) to enforce these Terms
              against you as a third-party beneficiary thereof. You represent
              and warrant that (i) you are not located in a country that is
              subject to a U.S. Government embargo, or that has been designated
              by the U.S. Government as a terrorist-supporting country; and (ii)
              you are not listed on any U.S. Government list of prohibited or
              restricted parties. You must also comply with any applicable
              third-party terms of service when using the App.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="7">
        <li class="c0 c22">
          <h1 style="display: inline">
            <span class="c2 c3"
              >License to Access and Use the Services and Impostors Content;
              General Prohibitions</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c22 c27">
          <h2 style="display: inline">
            <span class="c6 c2"
              >You are hereby granted a limited, nonexclusive, nontransferable,
              nonsublicensable license to access and use the Services and
              Impostors Content (as defined in Section 9); provided, however,
              that such license is subject to these Terms and does not include
              any right to:</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-2 start" start="1">
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >modify, mark any derivative uses of, sell, resell or use
              commercially the Services or Impostors Content (or any portion
              thereof), or distribute, publicly perform or publicly display any
              Impostors Content;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >download (other than page caching) any portion of the Services or
              Impostors Content, except as expressly permitted by us;
            </span>
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use, display, mirror or frame the Services or any individual
              element within the Services, Impostors Content or other Super
              Studios proprietary information, or the layout and design of any
              page or form contained on a page, without our express written
              consent;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >provide false or misleading information to Super Studios
              (including posing as another person or create a misleading
              username);</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use or attempt to use another user’s digital wallet without
              authorization from such user and Super Studios;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use the Services in any manner that could interfere with,
              disrupt, negatively affect or inhibit other users from fully
              enjoying the Services, or that could damage, disable, overburden
              or impair the functioning of the Services in any manner (including
              by engaging in any activity that poses a threat to the Services or
              Super Studios, for example by distributing a virus or other
              harmful code, or through unauthorized access to the Site or other
              users’ digital wallets);</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >develop, utilize, or disseminate any software, or interact with
              any API in any manner, that could damage, harm, or impair the
              Services;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >reverse engineer, or attempt to decipher, decompile, disassemble
              or reverse engineer, any aspect of the Services, or do anything
              that might discover source code or bypass or circumvent measures
              employed to prevent or limit access to any Services, area or code
              of the Services;</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >access, tamper with, or use non-public areas of the Services,
              Super Studios’s computer systems, or the technical delivery
              systems of Super Studios’s providers;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >attempt to probe, scan or test the vulnerability of any Super
              Studios system or network or breach any security or authentication
              measures;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >avoid, bypass, remove, deactivate, impair, descramble or
              otherwise circumvent any technological measure implemented by
              Super Studios or any of Super Studios’ providers or any other
              third party (including another user) to protect the
              Services;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >attempt to access or search the Services or download content from
              the Services &nbsp;using any engine, software, tool, agent, device
              or mechanism (including any robot, spider, crawler, scraper,
              script, browser extension, offline reader, data mining tools or
              the like) or other automated means or interface not authorized by
              us to access the Services, extract data or otherwise interfere
              with or modify the rendering of Services pages or functionality
              other than the software and/or search agents provided by Super
              Studios or other generally available third-party web
              browsers;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use data collected from our Services (including any personally
              identifiable data) to contact individuals, companies, or other
              persons or entities, or for any direct marketing activity
              (including without limitation, email marketing, SMS marketing,
              telemarketing, and direct marketing);</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use the Services to engage in any lottery, bidding fee auctions,
              contests, sweepstakes, or other games of chance;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c2"
              >engage or assist in any activity that violates any law, statute,
              ordinance, regulation, or sanctions program, including but not
              limited to the U.S. Department of Treasury’s Office of Foreign
              Assets Control (“</span
            ><span class="c2 c3">OFAC</span
            ><span class="c6 c2"
              >”), or that involves proceeds of any unlawful activity (including
              but not limited to money laundering, terrorist financing or
              deliberately engaging in activities designed to adversely affect
              the performance of the Services);</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >engage in wash trading or other deceptive or manipulative trading
              activities;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use the Services to carry out any financial activities subject to
              registration or licensing, including but not limited to creating,
              listing, or buying securities, commodities, options, real estate,
              or debt instruments;</span
            >
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use the Services to participate in fundraising for a business,
              protocol, or platform, including but not limited to creating,
              listing, or buying assets that are redeemable for financial
              instruments, assets that give owners the rights to participate in
              an ICO or any Securities offering, or assets that entitle owners
              to financial rewards, including but not limited to, DeFi (or
              decentralized finance) yield bonuses, staking bonuses, and burn
              discounts;
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >send any unsolicited or unauthorized advertising, promotional
              materials, email, junk mail, spam, chain letters or other form of
              solicitation;
            </span>
          </h3>
        </li>
        <li class="c11">
          <h3 style="display: inline">
            <span class="c6 c2"
              >use the Services, or any portion thereof, for any commercial
              purpose or for the benefit of any third party or in any manner not
              permitted by these Terms;
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >forge any TCP/IP packet header or any part of the header
              information in any email or newsgroup posting, or in any way use
              the Services to send altered, deceptive or false
              source-identifying information;
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >interfere with, or attempt to interfere with, the access of any
              user, host or network, including, without limitation, sending a
              virus, overloading, flooding, spamming, or mail-bombing the
              Services;
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >collect or store any personally identifiable information from the
              Services from other users of the Services without their express
              permission;
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >impersonate or misrepresent your affiliation with any person or
              entity;</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >fabricate in any way any transaction or process related thereto;
            </span>
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >disguise or interfere in any way with the IP address of the
              computer you are using to access or use the Services or that
              otherwise prevents us from correctly identifying the IP address of
              the computer you are using to access the Services;</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >transmit, exchange, or otherwise support the direct or indirect
              proceeds of criminal or fraudulent activity; or</span
            >
          </h3>
        </li>
        <li class="c13">
          <h3 style="display: inline">
            <span class="c6 c2"
              >otherwise use the Services for any illegal or unauthorized
              purpose, or engage in, encourage or promote any activity that
              violates these Terms.</span
            >
          </h3>
        </li>
      </ol>
      <p class="c18 c23"><span class="c1"></span></p>
      <p class="c26">
        <span class="c6 c2"
          >Super Studios is not obligated to monitor access to or use of the
          Services or to review or edit any content. However, we have the right
          to do so for the purpose of operating the Services, to ensure
          compliance with these Terms and to comply with applicable law or other
          legal requirements. We reserve the right, but are not obligated, to
          remove or disable access to any content, at any time and without
          notice, including, but not limited to, if we, at our sole discretion,
          consider it objectionable or in violation of these Terms. We have the
          right to investigate violations of these Terms or conduct that affects
          the Services. We may also consult and cooperate with law enforcement
          authorities to prosecute users who violate the law.
        </span>
      </p>
      <ol class="c4 lst-kix_list_1-0" start="8">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Hyperlinks</span><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >You are granted a limited, revocable, nonexclusive,
              nontransferable right to create a text hyperlink to the Services
              for noncommercial purposes, provided that such link does not
              portray Super Studios or our affiliates or any of our products or
              services in a false, misleading, derogatory or otherwise
              defamatory manner, and provided further that the linking site does
              not contain any adult or illegal material or any material that is
              offensive, harassing or otherwise objectionable.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="9">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Super Studios Intellectual Property</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >Unless otherwise indicated in writing by us, the Services and all
              content and other materials contained therein, including, without
              limitation, the Impostors logo and all designs, text, graphics,
              pictures, information, data, software, sound files, other files
              and the selection and arrangement thereof (collectively, “</span
            ><span class="c2 c3">Impostors</span><span class="c2">&nbsp;</span
            ><span class="c2 c3">Content</span
            ><span class="c6 c2"
              >”) are the proprietary property of Super Studios or our
              affiliates, licensors or users, as applicable. You may not use any
              Impostors Content to link to the Services without our express
              written permission. You may not use framing techniques to enclose
              any Impostors Content without our express written consent.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Super Studios and its licensors exclusively own all right, title
              and interest in and to the Services, including all associated
              intellectual property rights therein. You acknowledge that the
              Services are protected by copyright, trademark, and other laws of
              the United States and foreign countries. You agree not to remove,
              alter or obscure any copyright, trademark, services mark or other
              proprietary rights notices incorporated in or accompanying the
              Services.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >References to any other products, services, processes or other
              information by name, trademark, manufacturer, supplier or
              otherwise on the Services does not constitute or imply
              endorsement, sponsorship or recommendation by Super Studios.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="10">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Third-Party Services</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Notwithstanding anything to the contrary in these Terms, the
              Services and Impostors Content may include software components
              provided by Super Studios or its affiliates or a third-party that
              are subject to separate license terms, in which case those license
              terms will govern such software components. &nbsp;Super Studios
              disclaims all liability with respect to such components, including
              your use thereof.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >The Services may contain links to third-party websites (“</span
            ><span class="c2 c3">Third-Party Websites</span
            ><span class="c2">”) and applications (“</span
            ><span class="c2 c3">Third-Party Applications</span
            ><span class="c6 c2"
              >”). Such Third-Party Websites and Third-Party Applications and
              are not under the control of Super Studios and Super Studios is
              not responsible for any Third-Party Websites or Third-Party
              Applications. Super Studios provides these Third-Party Websites
              and Third-Party Applications only as a convenience and does not
              review, approve, monitor, endorse, warrant, or make any
              representations with respect to Third-Party Websites or
              Third-Party Applications, or their products or Services. You use
              all links in Third-Party Websites, and Third-Party Applications at
              your own risk. When you leave our Services, our Terms and policies
              no longer govern. You should review all applicable agreements and
              policies, including privacy and data gathering practices, of any
              Third-Party Websites or Third-Party Applications, and should make
              whatever investigation you feel necessary or appropriate before
              proceeding with any transaction with any third party. You
              acknowledge sole responsibility for and assume all risk arising
              from, your use of any Third-Party Websites and Third-Party
              Applications.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="11">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Termination</span><span class="c2 c6">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Notwithstanding anything contained in these Terms, we reserve the
              right, without notice and in our sole discretion, to suspend or
              terminate your right to access or use the Services at any time and
              for any or no reason, and you acknowledge and agree that we shall
              have no liability or obligation to you in such event and that you
              will not be entitled to a refund of any amounts that you have
              already paid to us or any third party, to the fullest extent
              permitted by applicable law. You may disconnect your digital
              wallet at any time.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >The following Sections will survive the expiration or termination
              of these Terms and any termination, discontinuation or
              cancellation of the Services: all defined terms and Sections
              4(c)(ii), 5, 7, 9, 11, 12, 13, 15, 17, 18, and 19.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="12">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Indemnification</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >To the fullest extent permitted by applicable law, you agree to
              indemnify, defend and hold harmless Super Studios, and our
              respective past, present and future employees, officers,
              directors, contractors, consultants, equity holders, suppliers,
              vendors, service providers, parent companies, subsidiaries,
              affiliates, agents, representatives, predecessors, successors and
              assigns (individually and collectively, the “</span
            ><span class="c2 c3">Super Studios Parties</span
            ><span class="c2"
              >”), from and against all actual or alleged third party claims,
              damages, awards, judgments, losses, liabilities, obligations,
              penalties, interest, fees, expenses (including, without
              limitation, attorneys’ fees and expenses) and costs (including,
              without limitation, court costs, costs of settlement and costs of
              pursuing indemnification and insurance), of every kind and nature
              whatsoever, whether known or unknown, foreseen or unforeseen,
              matured or unmatured, or suspected or unsuspected, in law or
              equity, whether in tort, contract or otherwise (collectively,
              “</span
            ><span class="c2 c3">Claims</span
            ><span class="c6 c2"
              >”), including, but not limited to, damages to property or
              personal injury, that are caused by, arise out of or are related
              to: (i) your access to or use of the Services; (ii) your Feedback;
              (iii) your violation of these Terms, or breach of any
              representation, warranty or covenant contained in these Terms;
              (iv) your use or disposal of any NFTs; (v) your violation of the
              rights of a third party or of applicable law; or (vi) any Claim
              that the NFT is, or may be deemed, a Security under the laws of
              any jurisdiction. You agree to promptly notify Super Studios of
              any Claims and cooperate with the Super Studios Parties in
              defending such Claims. You further agree that the Super Studios
              Parties shall have control of the defense or settlement of any
              third-party Claims. You may not settle or otherwise compromise any
              claim subject to this Section without Super Studios’ prior written
              approval. THIS INDEMNITY IS IN ADDITION TO, AND NOT IN LIEU OF,
              ANY OTHER INDEMNITIES SET FORTH IN A WRITTEN AGREEMENT BETWEEN YOU
              AND SUPER STUDIOS.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="13">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Disclaimers</span><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >EXCEPT AS EXPRESSLY PROVIDED TO THE CONTRARY IN A WRITING BY
              SUPER STUDIOS, THE SERVICES, IMPOSTORS CONTENT CONTAINED THEREIN,
              AND ANY NFTS OR OTHER CRYPTOCURRENCY ASSETS LISTED THEREIN ARE
              PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS WITHOUT WARRANTIES
              OR CONDITIONS OF ANY KIND, EITHER EXPRESS OR IMPLIED. SUPER
              STUDIOS (AND ITS SUPPLIERS) MAKE NO WARRANTY THAT THE SERVICES:
              (I) WILL MEET YOUR REQUIREMENTS; (II) WILL BE AVAILABLE ON AN
              UNINTERRUPTED, TIMELY, SECURE, OR ERROR-FREE BASIS; OR (III) WILL
              BE ACCURATE, RELIABLE, COMPLETE, LEGAL, OR SAFE. SUPER STUDIOS
              DISCLAIMS ALL OTHER WARRANTIES OR CONDITIONS, EXPRESS OR IMPLIED,
              INCLUDING, WITHOUT LIMITATION, INCLUDING ANY IMPLIED WARRANTY OF
              MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, QUIET ENJOYMENT
              OR NON-INFRINGEMENT, TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE
              LAW, AS TO THE SERVICES, IMPOSTORS CONTENT CONTAINED THEREIN AND
              ANY NFTS LISTED THEREIN.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >WE FURTHER EXPRESSLY DISCLAIM ALL LIABILITY OR RESPONSIBILITY IN
              CONNECTION WITH THIRD-PARTY SERVICES. NOTHING HEREIN NOR ANY USE
              OF OUR SERVICES IN CONNECTION WITH THIRD PARTY SERVICES
              CONSTITUTES OUR ENDORSEMENT, RECOMMENDATION OR ANY OTHER
              AFFILIATION OF OR WITH ANY THIRD-PARTY SERVICES.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >SUPER STUDIOS DOES NOT REPRESENT OR WARRANT THAT ANY CONTENT ON
              THE SERVICES IS ACCURATE, COMPLETE, RELIABLE, CURRENT OR
              ERROR-FREE. WE WILL NOT BE LIABLE FOR ANY LOSS OF ANY KIND FROM
              ANY ACTION TAKEN OR TAKEN IN RELIANCE ON MATERIAL OR INFORMATION,
              CONTAINED ON THE SERVICES. WHILE SUPER STUDIOS ATTEMPTS TO MAKE
              YOUR ACCESS TO AND USE OF THE SERVICES AND ANY CONTENT THEREIN
              SAFE, SUPER STUDIOS CANNOT AND DOES NOT REPRESENT OR WARRANT THAT
              THE SERVICES, ANY CONTENT THEREIN, ANY NFTS LISTED THEREIN, OR OUR
              SERVERS ARE FREE OF VIRUSES OR OTHER HARMFUL COMPONENTS. WE CANNOT
              GUARANTEE THE SECURITY OF ANY DATA THAT YOU DISCLOSE ONLINE. YOU
              ACCEPT THE INHERENT SECURITY RISKS OF PROVIDING INFORMATION AND
              DEALING ONLINE OVER THE INTERNET AND WILL NOT HOLD US RESPONSIBLE
              FOR ANY BREACH OF SECURITY.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >WE WILL NOT BE RESPONSIBLE OR LIABLE TO YOU FOR ANY LOSS AND TAKE
              NO RESPONSIBILITY FOR, AND WILL NOT BE LIABLE TO YOU FOR, ANY USE
              &nbsp;OF OR THE SERVICES AND/OR NFTS, INCLUDING BUT NOT LIMITED TO
              ANY LOSSES, DAMAGES OR CLAIMS ARISING FROM: (I) USER ERROR SUCH AS
              FORGOTTEN PASSWORDS, INCORRECTLY CONSTRUCTED TRANSACTIONS, OR
              MISTYPED WALLET ADDRESSES; (II) SERVER FAILURE OR DATA LOSS; (III)
              BLOCKCHAIN NETWORKS, CRYPTOCURRENCY WALLETS OR CORRUPT FILES; (IV)
              UNAUTHORIZED ACCESS TO THE SERVICES; OR (V) ANY THIRD PARTY
              ACTIVITIES, INCLUDING WITHOUT LIMITATION THE USE OF VIRUSES,
              PHISHING, BRUTEFORCING OR OTHER MEANS OF ATTACK.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >NFTS ARE INTANGIBLE DIGITAL ASSETS. THEY EXIST ONLY BY VIRTUE OF
              THE OWNERSHIP RECORD MAINTAINED IN THE APPLICABLE BLOCKCHAIN
              NETWORK. ANY TRANSFER OF TITLE THAT MIGHT OCCUR IN ANY UNIQUE
              DIGITAL ASSET OCCURS ON THE DECENTRALIZED LEDGER WITHIN SUCH
              BLOCKCHAIN NETWORK. WE DO NOT GUARANTEE THAT SUPER STUDIOS OR ANY
              SUPER STUDIOS PARTY CAN EFFECT THE TRANSFER OF TITLE OR RIGHT IN
              ANY NFTS OR OTHER DIGITAL ASSETS, OR THAT ANY ASSOCIATED PAYMENT
              WILL BE SUCCESSFUL.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >YOU BEAR FULL RESPONSIBILITY FOR VERIFYING THE IDENTITY,
              LEGITIMACY, AND AUTHENTICITY OF ASSETS YOU PURCHASE THROUGH THE
              SERVICES. NOTWITHSTANDING INDICATORS AND MESSAGES THAT SUGGEST
              VERIFICATION, SUPER STUDIOS MAKES NO CLAIMS ABOUT THE IDENTITY,
              LEGITIMACY, OR AUTHENTICITY OF ASSETS ON THE SITE.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >THE SERVICES &nbsp;MAY NOT BE AVAILABLE DUE TO ANY NUMBER OF
              FACTORS INCLUDING, BUT NOT LIMITED TO, PERIODIC SYSTEM
              MAINTENANCE, SCHEDULED OR UNSCHEDULED, ACTS OF GOD, UNAUTHORIZED
              ACCESS, VIRUSES, DENIAL OF SERVICE &nbsp;OR OTHER ATTACKS,
              TECHNICAL FAILURE OF THE SERVICES AND/OR TELECOMMUNICATIONS
              INFRASTRUCTURE OR DISRUPTION, AND THEREFORE WE EXPRESSLY DISCLAIM
              ANY EXPRESS OR IMPLIED WARRANTY REGARDING THE USE AND/OR
              AVAILABILITY, ACCESSIBILITY, SECURITY OR PERFORMANCE OF THE
              SERVICES &nbsp;CAUSED BY SUCH FACTORS. &nbsp;WE DO NOT MAKE ANY
              REPRESENTATIONS OR WARRANTIES AGAINST THE POSSIBILITY OF DELETION,
              MISDELIVERY OR FAILURE TO STORE COMMUNICATIONS, PERSONALIZED
              SETTINGS OR OTHER DATA.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Super Studios is not responsible for sustained casualties due to
              vulnerability or any kind of failure, abnormal behavior of
              software (e.g., wallet, smart contract), blockchains or any other
              features of the NFTs. Super Studios is not responsible for
              casualties due to late report by developers or representatives (or
              no report at all) of any issues with the blockchain supporting
              NFTs, including forks, technical node issues or any other issues
              having fund losses as a result.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >SOME JURISDICTIONS DO NOT ALLOW THE EXCLUSION OF CERTAIN
              WARRANTIES. ACCORDINGLY, SOME OF THE ABOVE DISCLAIMERS OF
              WARRANTIES MAY NOT APPLY TO YOU.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="14">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Assumption of Risk</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2">You accept and acknowledge:</span>
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-2 start" start="1">
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >The prices and liquidity of cryptocurrency assets (including any
              NFTs) are extremely volatile. Fluctuations in the price of other
              digital assets could materially and adversely affect the NFTs made
              available through the Services, which may also be subject to
              significant price volatility. We cannot guarantee that any
              Purchasers of NFTs will not lose money.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >You are solely responsible for determining what, if any, taxes
              apply to your transactions through the Services. Neither Super
              Studios nor any other Super Studios affiliates is responsible for
              determining the taxes that apply to such transactions.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >Our Services do not store, send, or receive cryptocurrency
              assets. This is because cryptocurrency assets exist only by virtue
              of the ownership record maintained on its supporting blockchain.
              Any transfer of cryptocurrency assets occurs within the supporting
              blockchain and not on the Services. Transactions in NFTs may be
              irreversible, and, accordingly, losses due to fraudulent or
              accidental transactions may not be recoverable. Some transactions
              in NFTs shall be deemed to be made when recorded on a public
              ledger, which is not necessarily the date or time that you
              initiated the transaction.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >There are risks associated with using an Internet based currency,
              including but not limited to, the risk of hardware, software and
              Internet connections, the risk of malicious software introduction,
              and the risk that third parties may obtain unauthorized access to
              information stored within your wallet. You accept and acknowledge
              that Super Studios will not be responsible for any communication
              failures, disruptions, errors, distortions or delays you may
              experience when using the Services for transactions, however
              caused.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >A lack of use or public interest in the creation and development
              of distributed ecosystems could negatively impact the development
              of those ecosystems and related applications, and could therefore
              also negatively impact the potential utility or value of a certain
              NFT.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >The Services may rely on third-party platforms to perform
              transactions with respect to any cryptocurrency assets. If we are
              unable to maintain a good relationship with such platform
              providers; if the terms and conditions or pricing of such platform
              providers change; if we violate or cannot comply with the terms
              and conditions of such platforms; or if any of such platforms
              loses market share or falls out of favor or is unavailable for a
              prolonged period of time, access to and use of the Services will
              suffer.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >There are risks associated with purchasing user generated
              content, including but not limited to, the risk of purchasing
              counterfeit assets, mislabeled assets, assets that are vulnerable
              to metadata decay, assets on smart contracts with bugs, and assets
              that may become untransferable. Super Studios reserves the right
              to hide collections, contracts, and assets affected by any of
              these issues or by other issues. Assets you purchase may become
              inaccessible on Super Studios. Under no circumstances shall the
              inability to view your assets on Super Studios serve as grounds
              for a claim against Super Studios.</span
            >
          </h3>
        </li>
        <li class="c8">
          <h3 style="display: inline">
            <span class="c6 c2"
              >By accessing and using the Services, you represent that you
              understand the inherent risks associated with using cryptographic
              and blockchain-based systems, and that you have a working
              knowledge of digital assets. Such systems may have vulnerabilities
              or other failures, or other abnormal behavior. Super Studios is
              not responsible for any issues with the Blockchains, including
              forks, technical node issues or any other issues having fund
              losses as a result. You acknowledge that the cost and speed of
              transacting with cryptographic and blockchain-based systems such
              as Ethereum are variable and may increase at any time. You further
              acknowledge the risk that your digital assets may lose some or all
              of their value while they are supplied to or from the Services.
              You further acknowledge that we are not responsible for any of
              these variables or risks and cannot be held liable for any
              resulting losses that you experience while accessing the
              Services.&nbsp;Accordingly, you understand and agree to assume
              full responsibility for all of the risks of accessing and using
              and interacting with the Services.
            </span>
          </h3>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="15">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Limitation of Liability</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >TO THE FULLEST EXTENT PERMITTED BY LAW, IN NO EVENT WILL SUPER
              STUDIOS NOR ITS SERVICE PROVIDERS INVOLVED IN CREATING, PRODUCING,
              OR DELIVERING THE SERVICES BE LIABLE TO YOU OR ANY THIRD PARTY FOR
              ANY LOST PROFIT OR ANY INDIRECT, CONSEQUENTIAL, EXEMPLARY,
              INCIDENTAL, SPECIAL OR PUNITIVE DAMAGES, OR DAMAGES FOR LOST
              PROFITS, LOST REVENUES, LOST SAVINGS, LOST BUSINESS OPPORTUNITY,
              LOSS OF DATA OR GOODWILL, SERVICE INTERRUPTION, COMPUTER DAMAGE OR
              SYSTEM FAILURE OR THE COST OF SUBSTITUTE SERVICES OF ANY KIND
              ARISING OUT OF OR IN CONNECTION WITH THESE TERMS OR FROM THE USE
              OF OR INABILITY TO USE THE SERVICES OR NFTS, WHETHER BASED ON
              WARRANTY, CONTRACT, TORT (INCLUDING NEGLIGENCE), PRODUCT LIABILITY
              OR ANY OTHER LEGAL THEORY, EVEN IF FORESEEABLE AND EVEN IF SUPER
              STUDIOS OR ITS SERVICE PROVIDERS HAVE BEEN ADVISED OF THE
              POSSIBILITY OF SUCH DAMAGES, EVEN IF A LIMITED REMEDY SET FORTH
              HEREIN IS FOUND TO HAVE FAILED OF ITS ESSENTIAL PURPOSE. ACCESS
              TO, AND USE OF, THE SERVICES, THE NFTS, IMPOSTORS CONTENT, OR ANY
              OTHER SUPER STUDIOS PRODUCTS OR THIRD-PARTY SITES AND PRODUCTS ARE
              AT YOUR OWN DISCRETION AND RISK, AND YOU WILL BE SOLELY
              RESPONSIBLE FOR ANY DAMAGE TO YOUR COMPUTER SYSTEM OR MOBILE
              DEVICE OR LOSS OF DATA RESULTING THEREFROM.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >NOTWITHSTANDING ANYTHING TO THE CONTRARY CONTAINED HEREIN, IN NO
              EVENT SHALL THE MAXIMUM AGGREGATE LIABILITY OF SUPER STUDIOS
              &nbsp;AND ITS AGENTS, REPRESENTATIVES, AND AFFILIATES ARISING OUT
              OF OR IN ANY WAY RELATED TO THESE TERMS OR FROM THE USE OF OR
              INABILITY TO USE THE SERVICES OR NFTS EXCEED THE AMOUNTS YOU HAVE
              PAID TO SUPER STUDIOS FOR USE OF THE SERVICES OR ONE HUNDRED
              UNITED STATES DOLLARS ($100), IF YOU HAVE NOT HAD ANY PAYMENT
              OBLIGATIONS TO SUPER STUDIOS, AS APPLICABLE.
            </span>
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >Some jurisdictions do not allow the exclusion or limitation of
              incidental or consequential damages, so the above limitation or
              exclusion may not apply to you. Some jurisdictions also limit
              disclaimers or limitations of liability for personal injury from
              consumer products, so this limitation may not apply to personal
              injury claims.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >THE EXCLUSIONS AND LIMITATIONS OF DAMAGES SET FORTH ABOVE ARE
              FUNDAMENTAL ELEMENTS OF THE BASIS OF THE BARGAIN BETWEEN SUPER
              STUDIOS AND YOU.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="16">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Modifications to the Services</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >We reserve the right in our sole discretion to modify, suspend or
              discontinue, temporarily or permanently, the Services (or any
              features or parts thereof) at any time and without liability
              therefore.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="17">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Dispute Resolution; Arbitration</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Dispute Resolution</span
            ><span class="c2"
              >. Please read the following arbitration agreement in this Section
              (“</span
            ><span class="c2 c3">Arbitration Agreement</span
            ><span class="c6 c2"
              >”) carefully. It requires you to arbitrate disputes with Super
              Studios and limits the manner in which you can seek relief from
              us. This Arbitration Agreement will survive the termination of
              your relationship with Super Studios.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Informal Resolution of Disputes.</span
            ><span class="c2"
              >&nbsp;You and Super Studios must first attempt to resolve any
              dispute, claim or controversy arising out of or relating to these
              Terms or the breach, termination, enforcement, interpretation or
              validity thereof or the use of the Services (collectively, “</span
            ><span class="c2 c3">Disputes</span
            ><span class="c6 c2"
              >”) informally. &nbsp;Accordingly, neither you nor Super Studios
              may start a formal arbitration proceeding for at least sixty (60)
              days after one party notifies the other party of a claim in
              writing. &nbsp;As part of this informal resolution process, you
              must deliver your written notices via hand or first-class mail to
              us at [Super Studios, 10880 Wilshire Boulevard, Suite 1101, Los
              Angeles, CA 90024].</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Mandatory Arbitration of Disputes</span
            ><span class="c2"
              >. We each agree that any Dispute will be resolved solely by
              binding, individual arbitration and not in a class, representative
              or consolidated action or proceeding. You and Super Studios agree
              that the </span
            ><span class="c2 c12">U.S. Federal Arbitration Act </span
            ><span class="c2"
              >governs the interpretation and enforcement of these Terms, and
              that you and Super Studios are each waiving the right to a trial
              by jury or to participate in a class action.</span
            ><span class="c2 c12">&nbsp;</span
            ><span class="c6 c2"
              >This arbitration provision shall survive termination of these
              Terms.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Applicability of Arbitration Agreement</span
            ><span class="c6 c2"
              >. You agree that any dispute or claim relating in any way to your
              access or use of the Services, to any products sold or distributed
              through the Services, or to any aspect of your relationship with
              Super Studios, will be resolved by binding arbitration, rather
              than in court, except that (i) you may assert claims in small
              claims court if your claims qualify; and (ii) you or Super Studios
              may seek equitable relief in court for infringement or other
              misuse of intellectual property rights (such as trademarks, trade
              dress, domain names, trade secrets, copyrights, and
              patents).</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Arbitration Rules and Forum</span
            ><span class="c2"
              >. The Federal Arbitration Act governs the interpretation and
              enforcement of this Arbitration Agreement. The arbitration will be
              conducted by the American Arbitration Association (“</span
            ><span class="c2 c3">AAA</span
            ><span class="c2"
              >”) under its Consumer Arbitration Rules (the “</span
            ><span class="c2 c3">AAA Rules</span
            ><span class="c2"
              >”) then in effect, except as modified by these Terms. The AAA
              Rules are available at </span
            ><span class="c14 c2"
              ><a class="c10" href="http://www.adr.org">www.adr.org</a></span
            ><span class="c2"
              >&nbsp;or by calling 1-800-778-7879. A party who wishes to start
              arbitration must submit a written Demand for Arbitration to AAA
              and give notice to the other party as specified in the AAA Rules.
              The AAA provides a form Demand for Arbitration at </span
            ><span class="c2 c14"
              ><a
                class="c10"
                href="http://www.adr.org/aaa/ShowPDF?doc%3DADRSTG_004175"
                >www.adr.org</a
              ></span
            ><span class="c6 c2"
              >. Any arbitration hearings will take place in the county (or
              parish) where you live, unless we both agree to a different
              location. The parties agree that the arbitrator shall have
              exclusive authority to decide all issues relating to the
              interpretation, applicability, enforceability and scope of this
              arbitration agreement.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Arbitration Costs</span
            ><span class="c6 c2"
              >. Payment of all filing, administration and arbitrator fees will
              be governed by the AAA Rules, and we won’t seek to recover the
              administration and arbitrator fees we are responsible for paying,
              unless the arbitrator finds your Dispute frivolous. If we prevail
              in arbitration, we’ll pay all of our attorneys’ fees and costs and
              won’t seek to recover them from you. If you prevail in arbitration
              you will be entitled to an award of attorneys’ fees and expenses
              to the extent provided under applicable law.</span
            >
          </h2>
        </li>
        <li class="c9">
          <span class="c7 c2 c3">Authority of Arbitrator</span
          ><span class="c6 c2"
            >. The arbitrator shall have exclusive authority to (i) determine
            the scope and enforceability of this Arbitration Agreement and (ii)
            resolve any dispute related to the interpretation, applicability,
            enforceability or formation of this Arbitration Agreement including,
            but not limited to any claim that all or any part of this
            Arbitration Agreement is void or voidable. The arbitration will
            decide the rights and liabilities, if any, of you and Super Studios.
            The arbitration proceeding will not be consolidated with any other
            matters or joined with any other cases or parties. The arbitrator
            shall have the authority to grant motions dispositive of all or part
            of any claim. The arbitrator shall have the authority to award
            monetary damages and to grant any non- monetary remedy or relief
            available to an individual under applicable law, the arbitral
            forum’s rules, and the Terms (including the Arbitration Agreement).
            The arbitrator shall issue a written award and statement of decision
            describing the essential findings and conclusions on which the award
            is based, including the calculation of any damages awarded. The
            arbitrator has the same authority to award relief on an individual
            basis that a judge in a court of law would have. The award of the
            arbitrator is final and binding upon you and us.</span
          >
        </li>
        <li class="c9">
          <span class="c7 c2 c3">Injunctive and Declarative Relief</span
          ><span class="c1">. </span
          ><span class="c6 c2"
            >Except as provided in Section 17(d) above, the arbitrator shall
            determine all issues of liability on the merits of any claim
            asserted by either party and may award declaratory or injunctive
            relief only in favor of the individual party seeking relief and only
            to the extent necessary to provide relief warranted by that party’s
            individual claim. To the extent that you or we prevail on a claim
            and seek public injunctive relief (that is, injunctive relief that
            has the primary purpose and effect of prohibiting unlawful acts that
            threaten future injury to the public), the entitlement to and extent
            of such relief must be litigated in a civil court of competent
            jurisdiction and not in arbitration. The parties agree that
            litigation of any issues of public injunctive relief shall be stayed
            pending the outcome of the merits of any individual claims in
            arbitration.</span
          >
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Waiver of Jury Trial</span
            ><span class="c6 c2"
              >. YOU AND SUPER STUDIOS HEREBY WAIVE ANY CONSTITUTIONAL AND
              STATUTORY RIGHTS TO SUE IN COURT AND HAVE A TRIAL IN FRONT OF A
              JUDGE OR A JURY. You and Super Studios are instead electing that
              all claims and disputes shall be resolved by arbitration under
              this Arbitration Agreement, except as specified in Section
              &lrm;17(d) above.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3"
              >Waiver of Class Actions or Other Non-Individualized Relief</span
            ><span class="c2"
              >. ALL CLAIMS AND DISPUTES WITHIN THE SCOPE OF THIS ARBITRATION
              AGREEMENT MUST BE ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A
              OR COLLECTIVE CLASS BASIS, ONLY INDIVIDUAL RELIEF IS AVAILABLE,
              AND CLAIMS OF MORE THAN ONE CUSTOMER OR USER CANNOT BE ARBITRATED
              OR CONSOLIDATED WITH THOSE OF ANY OTHER CUSTOMER OR USER. If a
              decision is issued stating that applicable law precludes
              enforcement of any part of this subsection’s limitations as to a
              given claim for relief, then that claim must be severed from the
              arbitration and brought in the state or Federal courts located in
              Los Angeles, California,</span
            ><span>&nbsp;</span
            ><span class="c6 c2"
              >and each party consents to the exclusive jurisdiction of those
              courts. All other claims shall be arbitrated.</span
            >
          </h2>
        </li>
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2 c3">Severability</span
            ><span class="c6 c2"
              >. Except as provided in Section &lrm;17(j), if any part or parts
              of this Arbitration Agreement are found under the law to be
              invalid or unenforceable, then such specific part or parts shall
              be of no force and effect and shall be severed and the remainder
              of the Arbitration Agreement shall continue in full force and
              effect.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="18">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Governing Law and Venue</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >These Terms and your access to and use of the Services and
              Impostors Content will be governed by and construed and enforced
              in accordance with the laws of Delaware, without regard to or
              application of its conflict of laws rules. The parties hereby
              agree to submit to the jurisdiction of, and agree that venue is
              proper in, those courts in any such legal action or proceeding.
              Any dispute between the parties that is not subject to arbitration
              or cannot be heard in small claims court, shall be resolved in the
              state or Federal courts located in Los Angeles, California, and
              each party consents to the exclusive jurisdiction of those
              courts.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="19">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Miscellaneous</span><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c6 c2"
              >These Terms constitute the entire and exclusive understanding and
              agreement between you and Super Studios relating to your access to
              and use of the Services and Impostors Content, and supersede any
              and all prior and contemporaneous oral and written discussions
              agreements, and understandings of any kind. Except where provided
              by applicable law in your jurisdiction, you may not assign or
              transfer these Terms, by operation of law or otherwise, without
              Super Studios’s prior written consent. Any attempt by you to
              assign or transfer these Terms absent our consent or your
              statutory right, without such consent, will be null. Super Studios
              may freely assign or transfer these Terms without restriction.
              Subject to the foregoing, these Terms will bind and inure to the
              benefit of the parties, their successors and permitted assigns.
              Any notices or other communications provided by Super Studios
              under these Terms will be given: (i) via email; or (ii) by posting
              to the Services. For notices made by email, the date of receipt
              will be deemed the date on which such notice is transmitted. Super
              Studios’s failure to assert any right or provision under these
              Terms shall not constitute a waiver of such right or provision.
              The waiver of any such right or provision will be effective only
              if in writing and signed by a duly authorized representative of
              Super Studios. Except as expressly set forth in these Terms, the
              exercise by either party of any of its remedies under these Terms
              will be without prejudice to its other remedies under these Terms
              or otherwise. If any term, clause or provision of these Terms is
              held invalid or unenforceable, then that term, clause or provision
              will be severable from these Terms and will not affect the
              validity or enforceability of any remaining part of that term,
              clause or provision, or any other term, clause or provision of
              these Terms.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="20">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c7 c2 c3">Notice for California Residents.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >Under California Civil Code Section 1789.3, California users are
              entitled to the following consumer rights notice: If you have a
              question or complaint regarding the Site, please send an email to </span
            ><span class="c14 c2"
              ><a class="c10" href="mailto:support@superfarm.io"
                >support@superfarm.io</a
              ></span
            ><span class="c6 c2"
              >. California residents may reach the Complaint Assistance Unit of
              the Division of Consumer Services of the California Department of
              Consumer Affairs by mail at 1625 North Market Blvd., Sacramento,
              CA 95834, or by telephone at (916) 445-1254 or (800)
              952-5210.</span
            >
          </h2>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-0" start="21">
        <li class="c0">
          <h1 style="display: inline">
            <span class="c2 c3">Contact Information</span
            ><span class="c6 c2">.</span>
          </h1>
        </li>
      </ol>
      <ol class="c4 lst-kix_list_1-1 start" start="1">
        <li class="c5">
          <h2 style="display: inline">
            <span class="c2"
              >If you have any questions or would like more information about
              Super Studios and/or the Services, please contact us via our </span
            ><span class="c14 c2"
              ><a class="c10" href="https://discord.gg/impostors"
                >Discord channel</a
              ></span
            ><span class="c2">&nbsp;or email us at </span
            ><span class="c14 c2"
              ><a class="c10" href="mailto:support@superfarm.io"
                >support@superfarm.io</a
              ></span
            ><span class="c2">&nbsp;.</span>
          </h2>
        </li>
      </ol>
    </div>
  </div>
</template>
<script>
import { computed, ref, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    const isLoggedIn = computed(() => {
      return store.state.ethers.address;
    });

    const initialize = async () => {};

    return {
      store,
      isLoggedIn,
      initialize
    };
  }
};
</script>

<style scoped lang="scss">
.privacy-container {
  padding: 65px;
  padding-top: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url('https://impostors.s3.amazonaws.com/assets/space-background.webp');
  background-position: top;
  background-size: 100% 100vh;
  background-repeat: no-repeat;
  width: 100%;
  @media (max-width: 650px) {
    padding-left: 18px;
    padding-right: 18px;
  }
}

.privacy-text-title {
  margin-bottom: 20px;
  font-family: DM Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 33px;
  line-height: 43px;
  width: 100%;
  max-width: 1400px;
  /* identical to box height */
}

.privacy-text-container {
  font-family: DM Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.8em;
  max-width: 1400px;
  width: 100%;
  @media (max-width: 650px) {
    font-size: 14px;
    & * {
      text-align: left !important;
    }
  }
}

a {
  color: var(--color-button-yellow);
}

.lst-kix_list_4-1 > li {
  counter-increment: lst-ctn-kix_list_4-1;
}
.lst-kix_list_2-1 > li {
  counter-increment: lst-ctn-kix_list_2-1;
}
.lst-kix_list_6-1 > li {
  counter-increment: lst-ctn-kix_list_6-1;
}
ol.lst-kix_list_3-1.start {
  counter-reset: lst-ctn-kix_list_3-1 0;
}
ol.lst-kix_list_6-6.start {
  counter-reset: lst-ctn-kix_list_6-6 0;
}
.lst-kix_list_5-0 > li {
  counter-increment: lst-ctn-kix_list_5-0;
}
ol.lst-kix_list_2-3.start {
  counter-reset: lst-ctn-kix_list_2-3 0;
}
ol.lst-kix_list_1-5.start {
  counter-reset: lst-ctn-kix_list_1-5 0;
}
ol.lst-kix_list_5-3.start {
  counter-reset: lst-ctn-kix_list_5-3 0;
}
.lst-kix_list_2-3 > li {
  counter-increment: lst-ctn-kix_list_2-3;
}
.lst-kix_list_4-3 > li {
  counter-increment: lst-ctn-kix_list_4-3;
}
ol.lst-kix_list_4-5.start {
  counter-reset: lst-ctn-kix_list_4-5 0;
}
.lst-kix_list_1-2 > li {
  counter-increment: lst-ctn-kix_list_1-2;
}
ol.lst-kix_list_3-7.start {
  counter-reset: lst-ctn-kix_list_3-7 0;
}
.lst-kix_list_5-2 > li {
  counter-increment: lst-ctn-kix_list_5-2;
}
.lst-kix_list_3-2 > li {
  counter-increment: lst-ctn-kix_list_3-2;
}
.lst-kix_list_5-0 > li:before {
  content: '' counter(lst-ctn-kix_list_5-0, decimal) '. ';
}
ol.lst-kix_list_6-0 {
  list-style-type: none;
}
ol.lst-kix_list_6-1 {
  list-style-type: none;
}
.lst-kix_list_5-4 > li {
  counter-increment: lst-ctn-kix_list_5-4;
}
.lst-kix_list_1-4 > li {
  counter-increment: lst-ctn-kix_list_1-4;
}
ol.lst-kix_list_1-6.start {
  counter-reset: lst-ctn-kix_list_1-6 0;
}
.lst-kix_list_5-3 > li:before {
  content: '' counter(lst-ctn-kix_list_5-3, decimal) '. ';
}
.lst-kix_list_5-2 > li:before {
  content: '' counter(lst-ctn-kix_list_5-2, decimal) '. ';
}
.lst-kix_list_5-1 > li:before {
  content: '(' counter(lst-ctn-kix_list_5-1, lower-latin) ') ';
}
.lst-kix_list_5-7 > li:before {
  content: '' counter(lst-ctn-kix_list_5-7, decimal) '. ';
}
.lst-kix_list_5-6 > li:before {
  content: '' counter(lst-ctn-kix_list_5-6, decimal) '. ';
}
.lst-kix_list_5-8 > li:before {
  content: '' counter(lst-ctn-kix_list_5-8, decimal) '. ';
}
ol.lst-kix_list_6-6 {
  list-style-type: none;
}
ol.lst-kix_list_6-7 {
  list-style-type: none;
}
.lst-kix_list_5-4 > li:before {
  content: '' counter(lst-ctn-kix_list_5-4, decimal) '. ';
}
ol.lst-kix_list_6-8 {
  list-style-type: none;
}
.lst-kix_list_5-5 > li:before {
  content: '' counter(lst-ctn-kix_list_5-5, decimal) '. ';
}
ol.lst-kix_list_6-2 {
  list-style-type: none;
}
ol.lst-kix_list_6-3 {
  list-style-type: none;
}
ol.lst-kix_list_6-4 {
  list-style-type: none;
}
ol.lst-kix_list_6-5 {
  list-style-type: none;
}
ol.lst-kix_list_1-0.start {
  counter-reset: lst-ctn-kix_list_1-0 0;
}
.lst-kix_list_6-1 > li:before {
  content: '(' counter(lst-ctn-kix_list_6-1, lower-latin) ') ';
}
.lst-kix_list_6-3 > li:before {
  content: '(' counter(lst-ctn-kix_list_6-3, decimal) ') ';
}
.lst-kix_list_6-5 > li {
  counter-increment: lst-ctn-kix_list_6-5;
}
.lst-kix_list_6-8 > li {
  counter-increment: lst-ctn-kix_list_6-8;
}
.lst-kix_list_6-0 > li:before {
  content: '' counter(lst-ctn-kix_list_6-0, decimal) '. ';
}
.lst-kix_list_6-4 > li:before {
  content: '' counter(lst-ctn-kix_list_6-4, lower-latin) '. ';
}
.lst-kix_list_3-0 > li {
  counter-increment: lst-ctn-kix_list_3-0;
}
ol.lst-kix_list_4-0.start {
  counter-reset: lst-ctn-kix_list_4-0 0;
}
.lst-kix_list_3-6 > li {
  counter-increment: lst-ctn-kix_list_3-6;
}
.lst-kix_list_6-2 > li:before {
  content: '(' counter(lst-ctn-kix_list_6-2, lower-roman) ') ';
}
.lst-kix_list_2-5 > li {
  counter-increment: lst-ctn-kix_list_2-5;
}
.lst-kix_list_2-8 > li {
  counter-increment: lst-ctn-kix_list_2-8;
}
ol.lst-kix_list_3-2.start {
  counter-reset: lst-ctn-kix_list_3-2 0;
}
.lst-kix_list_6-8 > li:before {
  content: '' counter(lst-ctn-kix_list_6-8, lower-roman) ') ';
}
.lst-kix_list_6-5 > li:before {
  content: '' counter(lst-ctn-kix_list_6-5, lower-roman) '. ';
}
.lst-kix_list_6-7 > li:before {
  content: '' counter(lst-ctn-kix_list_6-7, lower-latin) ') ';
}
ol.lst-kix_list_2-4.start {
  counter-reset: lst-ctn-kix_list_2-4 0;
}
.lst-kix_list_6-6 > li:before {
  content: '' counter(lst-ctn-kix_list_6-6, decimal) ') ';
}
ol.lst-kix_list_1-3 {
  list-style-type: none;
}
ol.lst-kix_list_1-4 {
  list-style-type: none;
}
.lst-kix_list_2-7 > li:before {
  content: '' counter(lst-ctn-kix_list_2-7, decimal) '. ';
}
.lst-kix_list_2-7 > li {
  counter-increment: lst-ctn-kix_list_2-7;
}
ol.lst-kix_list_1-5 {
  list-style-type: none;
}
ol.lst-kix_list_1-6 {
  list-style-type: none;
}
ol.lst-kix_list_1-0 {
  list-style-type: none;
}
.lst-kix_list_2-5 > li:before {
  content: '' counter(lst-ctn-kix_list_2-5, decimal) '. ';
}
ol.lst-kix_list_6-2.start {
  counter-reset: lst-ctn-kix_list_6-2 0;
}
ol.lst-kix_list_1-1 {
  list-style-type: none;
}
ol.lst-kix_list_1-2 {
  list-style-type: none;
}
ol.lst-kix_list_4-6.start {
  counter-reset: lst-ctn-kix_list_4-6 0;
}
ol.lst-kix_list_3-0.start {
  counter-reset: lst-ctn-kix_list_3-0 0;
}
.lst-kix_list_5-7 > li {
  counter-increment: lst-ctn-kix_list_5-7;
}
ol.lst-kix_list_4-3.start {
  counter-reset: lst-ctn-kix_list_4-3 0;
}
ol.lst-kix_list_1-7 {
  list-style-type: none;
}
.lst-kix_list_4-7 > li {
  counter-increment: lst-ctn-kix_list_4-7;
}
ol.lst-kix_list_1-8 {
  list-style-type: none;
}
ol.lst-kix_list_2-5.start {
  counter-reset: lst-ctn-kix_list_2-5 0;
}
.lst-kix_list_2-6 > li {
  counter-increment: lst-ctn-kix_list_2-6;
}
.lst-kix_list_4-1 > li:before {
  content: '(' counter(lst-ctn-kix_list_4-1, lower-latin) ') ';
}
.lst-kix_list_4-3 > li:before {
  content: '' counter(lst-ctn-kix_list_4-3, decimal) '. ';
}
.lst-kix_list_4-5 > li:before {
  content: '' counter(lst-ctn-kix_list_4-5, decimal) '. ';
}
ol.lst-kix_list_5-7.start {
  counter-reset: lst-ctn-kix_list_5-7 0;
}
.lst-kix_list_1-8 > li {
  counter-increment: lst-ctn-kix_list_1-8;
}
ol.lst-kix_list_1-4.start {
  counter-reset: lst-ctn-kix_list_1-4 0;
}
.lst-kix_list_5-5 > li {
  counter-increment: lst-ctn-kix_list_5-5;
}
.lst-kix_list_3-5 > li {
  counter-increment: lst-ctn-kix_list_3-5;
}
ol.lst-kix_list_1-1.start {
  counter-reset: lst-ctn-kix_list_1-1 0;
}
.lst-kix_list_3-4 > li {
  counter-increment: lst-ctn-kix_list_3-4;
}
ol.lst-kix_list_4-4.start {
  counter-reset: lst-ctn-kix_list_4-4 0;
}
.lst-kix_list_6-4 > li {
  counter-increment: lst-ctn-kix_list_6-4;
}
.lst-kix_list_6-3 > li {
  counter-increment: lst-ctn-kix_list_6-3;
}
ol.lst-kix_list_1-3.start {
  counter-reset: lst-ctn-kix_list_1-3 0;
}
ol.lst-kix_list_2-8.start {
  counter-reset: lst-ctn-kix_list_2-8 0;
}
ol.lst-kix_list_1-2.start {
  counter-reset: lst-ctn-kix_list_1-2 0;
}
ol.lst-kix_list_6-1.start {
  counter-reset: lst-ctn-kix_list_6-1 0;
}
.lst-kix_list_1-1 > li:before {
  content: '(' counter(lst-ctn-kix_list_1-1, lower-latin) ') ';
}
.lst-kix_list_1-3 > li:before {
  content: '(' counter(lst-ctn-kix_list_1-3, decimal) ') ';
}
.lst-kix_list_4-8 > li {
  counter-increment: lst-ctn-kix_list_4-8;
}
.lst-kix_list_1-7 > li:before {
  content: '' counter(lst-ctn-kix_list_1-7, lower-latin) ') ';
}
ol.lst-kix_list_5-8.start {
  counter-reset: lst-ctn-kix_list_5-8 0;
}
ol.lst-kix_list_2-7.start {
  counter-reset: lst-ctn-kix_list_2-7 0;
}
.lst-kix_list_1-3 > li {
  counter-increment: lst-ctn-kix_list_1-3;
}
.lst-kix_list_1-5 > li:before {
  content: '' counter(lst-ctn-kix_list_1-5, lower-roman) '. ';
}
.lst-kix_list_5-6 > li {
  counter-increment: lst-ctn-kix_list_5-6;
}
.lst-kix_list_2-1 > li:before {
  content: '(' counter(lst-ctn-kix_list_2-1, lower-latin) ') ';
}
ol.lst-kix_list_6-0.start {
  counter-reset: lst-ctn-kix_list_6-0 0;
}
.lst-kix_list_2-3 > li:before {
  content: '' counter(lst-ctn-kix_list_2-3, decimal) '. ';
}
.lst-kix_list_4-2 > li {
  counter-increment: lst-ctn-kix_list_4-2;
}
ol.lst-kix_list_3-1 {
  list-style-type: none;
}
ol.lst-kix_list_3-2 {
  list-style-type: none;
}
.lst-kix_list_3-1 > li {
  counter-increment: lst-ctn-kix_list_3-1;
}
ol.lst-kix_list_3-3 {
  list-style-type: none;
}
ol.lst-kix_list_3-4.start {
  counter-reset: lst-ctn-kix_list_3-4 0;
}
.lst-kix_list_5-1 > li {
  counter-increment: lst-ctn-kix_list_5-1;
}
ol.lst-kix_list_3-4 {
  list-style-type: none;
}
ol.lst-kix_list_3-0 {
  list-style-type: none;
}
.lst-kix_list_1-1 > li {
  counter-increment: lst-ctn-kix_list_1-1;
}
ol.lst-kix_list_2-6.start {
  counter-reset: lst-ctn-kix_list_2-6 0;
}
.lst-kix_list_3-0 > li:before {
  content: '' counter(lst-ctn-kix_list_3-0, decimal) '. ';
}
.lst-kix_list_3-1 > li:before {
  content: '(' counter(lst-ctn-kix_list_3-1, lower-latin) ') ';
}
.lst-kix_list_3-2 > li:before {
  content: '' counter(lst-ctn-kix_list_3-2, decimal) '. ';
}
ol.lst-kix_list_1-8.start {
  counter-reset: lst-ctn-kix_list_1-8 0;
}
.lst-kix_list_4-0 > li {
  counter-increment: lst-ctn-kix_list_4-0;
}
.lst-kix_list_6-0 > li {
  counter-increment: lst-ctn-kix_list_6-0;
}
.lst-kix_list_3-5 > li:before {
  content: '' counter(lst-ctn-kix_list_3-5, decimal) '. ';
}
.lst-kix_list_3-4 > li:before {
  content: '' counter(lst-ctn-kix_list_3-4, decimal) '. ';
}
.lst-kix_list_3-3 > li:before {
  content: '' counter(lst-ctn-kix_list_3-3, decimal) '. ';
}
ol.lst-kix_list_3-5 {
  list-style-type: none;
}
ol.lst-kix_list_3-6 {
  list-style-type: none;
}
ol.lst-kix_list_3-7 {
  list-style-type: none;
}
ol.lst-kix_list_3-8 {
  list-style-type: none;
}
.lst-kix_list_3-8 > li:before {
  content: '' counter(lst-ctn-kix_list_3-8, decimal) '. ';
}
.lst-kix_list_2-0 > li {
  counter-increment: lst-ctn-kix_list_2-0;
}
.lst-kix_list_3-6 > li:before {
  content: '' counter(lst-ctn-kix_list_3-6, decimal) '. ';
}
.lst-kix_list_3-7 > li:before {
  content: '' counter(lst-ctn-kix_list_3-7, decimal) '. ';
}
ol.lst-kix_list_5-0.start {
  counter-reset: lst-ctn-kix_list_5-0 0;
}
ol.lst-kix_list_4-2.start {
  counter-reset: lst-ctn-kix_list_4-2 0;
}
ol.lst-kix_list_2-2 {
  list-style-type: none;
}
ol.lst-kix_list_2-3 {
  list-style-type: none;
}
ol.lst-kix_list_2-4 {
  list-style-type: none;
}
ol.lst-kix_list_2-5 {
  list-style-type: none;
}
.lst-kix_list_4-4 > li {
  counter-increment: lst-ctn-kix_list_4-4;
}
ol.lst-kix_list_2-0 {
  list-style-type: none;
}
ol.lst-kix_list_2-1 {
  list-style-type: none;
}
.lst-kix_list_4-8 > li:before {
  content: '' counter(lst-ctn-kix_list_4-8, decimal) '. ';
}
ol.lst-kix_list_6-4.start {
  counter-reset: lst-ctn-kix_list_6-4 0;
}
.lst-kix_list_4-7 > li:before {
  content: '' counter(lst-ctn-kix_list_4-7, decimal) '. ';
}
ol.lst-kix_list_5-6.start {
  counter-reset: lst-ctn-kix_list_5-6 0;
}
ol.lst-kix_list_4-1.start {
  counter-reset: lst-ctn-kix_list_4-1 0;
}
ol.lst-kix_list_4-8.start {
  counter-reset: lst-ctn-kix_list_4-8 0;
}
ol.lst-kix_list_3-3.start {
  counter-reset: lst-ctn-kix_list_3-3 0;
}
ol.lst-kix_list_2-6 {
  list-style-type: none;
}
ol.lst-kix_list_2-7 {
  list-style-type: none;
}
ol.lst-kix_list_2-8 {
  list-style-type: none;
}
.lst-kix_list_3-3 > li {
  counter-increment: lst-ctn-kix_list_3-3;
}
ol.lst-kix_list_6-3.start {
  counter-reset: lst-ctn-kix_list_6-3 0;
}
ol.lst-kix_list_5-5.start {
  counter-reset: lst-ctn-kix_list_5-5 0;
}
.lst-kix_list_2-2 > li {
  counter-increment: lst-ctn-kix_list_2-2;
}
ol.lst-kix_list_4-7.start {
  counter-reset: lst-ctn-kix_list_4-7 0;
}
.lst-kix_list_6-2 > li {
  counter-increment: lst-ctn-kix_list_6-2;
}
ol.lst-kix_list_5-0 {
  list-style-type: none;
}
.lst-kix_list_2-6 > li:before {
  content: '' counter(lst-ctn-kix_list_2-6, decimal) '. ';
}
.lst-kix_list_3-7 > li {
  counter-increment: lst-ctn-kix_list_3-7;
}
ol.lst-kix_list_5-1 {
  list-style-type: none;
}
ol.lst-kix_list_5-2 {
  list-style-type: none;
}
.lst-kix_list_2-4 > li:before {
  content: '' counter(lst-ctn-kix_list_2-4, decimal) '. ';
}
.lst-kix_list_2-8 > li:before {
  content: '' counter(lst-ctn-kix_list_2-8, decimal) '. ';
}
.lst-kix_list_6-6 > li {
  counter-increment: lst-ctn-kix_list_6-6;
}
ol.lst-kix_list_5-4.start {
  counter-reset: lst-ctn-kix_list_5-4 0;
}
ol.lst-kix_list_5-1.start {
  counter-reset: lst-ctn-kix_list_5-1 0;
}
ol.lst-kix_list_5-7 {
  list-style-type: none;
}
.lst-kix_list_6-7 > li {
  counter-increment: lst-ctn-kix_list_6-7;
}
ol.lst-kix_list_5-8 {
  list-style-type: none;
}
ol.lst-kix_list_5-3 {
  list-style-type: none;
}
ol.lst-kix_list_5-4 {
  list-style-type: none;
}
.lst-kix_list_1-7 > li {
  counter-increment: lst-ctn-kix_list_1-7;
}
ol.lst-kix_list_3-8.start {
  counter-reset: lst-ctn-kix_list_3-8 0;
}
ol.lst-kix_list_5-5 {
  list-style-type: none;
}
ol.lst-kix_list_5-6 {
  list-style-type: none;
}
.lst-kix_list_5-8 > li {
  counter-increment: lst-ctn-kix_list_5-8;
}
.lst-kix_list_4-0 > li:before {
  content: '' counter(lst-ctn-kix_list_4-0, decimal) '. ';
}
.lst-kix_list_3-8 > li {
  counter-increment: lst-ctn-kix_list_3-8;
}
ol.lst-kix_list_6-8.start {
  counter-reset: lst-ctn-kix_list_6-8 0;
}
.lst-kix_list_4-6 > li {
  counter-increment: lst-ctn-kix_list_4-6;
}
ol.lst-kix_list_1-7.start {
  counter-reset: lst-ctn-kix_list_1-7 0;
}
.lst-kix_list_4-4 > li:before {
  content: '' counter(lst-ctn-kix_list_4-4, decimal) '. ';
}
ol.lst-kix_list_2-2.start {
  counter-reset: lst-ctn-kix_list_2-2 0;
}
.lst-kix_list_1-5 > li {
  counter-increment: lst-ctn-kix_list_1-5;
}
ol.lst-kix_list_6-5.start {
  counter-reset: lst-ctn-kix_list_6-5 0;
}
.lst-kix_list_4-2 > li:before {
  content: '' counter(lst-ctn-kix_list_4-2, decimal) '. ';
}
.lst-kix_list_4-6 > li:before {
  content: '' counter(lst-ctn-kix_list_4-6, decimal) '. ';
}
ol.lst-kix_list_4-0 {
  list-style-type: none;
}
ol.lst-kix_list_4-1 {
  list-style-type: none;
}
ol.lst-kix_list_4-2 {
  list-style-type: none;
}
ol.lst-kix_list_4-3 {
  list-style-type: none;
}
.lst-kix_list_2-4 > li {
  counter-increment: lst-ctn-kix_list_2-4;
}
ol.lst-kix_list_6-7.start {
  counter-reset: lst-ctn-kix_list_6-7 0;
}
ol.lst-kix_list_3-6.start {
  counter-reset: lst-ctn-kix_list_3-6 0;
}
.lst-kix_list_5-3 > li {
  counter-increment: lst-ctn-kix_list_5-3;
}
ol.lst-kix_list_4-8 {
  list-style-type: none;
}
.lst-kix_list_1-0 > li:before {
  content: '' counter(lst-ctn-kix_list_1-0, decimal) '. ';
}
ol.lst-kix_list_4-4 {
  list-style-type: none;
}
ol.lst-kix_list_4-5 {
  list-style-type: none;
}
.lst-kix_list_1-2 > li:before {
  content: '(' counter(lst-ctn-kix_list_1-2, lower-roman) ') ';
}
ol.lst-kix_list_2-0.start {
  counter-reset: lst-ctn-kix_list_2-0 0;
}
ol.lst-kix_list_4-6 {
  list-style-type: none;
}
ol.lst-kix_list_4-7 {
  list-style-type: none;
}
.lst-kix_list_1-4 > li:before {
  content: '' counter(lst-ctn-kix_list_1-4, lower-latin) '. ';
}
ol.lst-kix_list_3-5.start {
  counter-reset: lst-ctn-kix_list_3-5 0;
}
.lst-kix_list_1-0 > li {
  counter-increment: lst-ctn-kix_list_1-0;
}
.lst-kix_list_1-6 > li {
  counter-increment: lst-ctn-kix_list_1-6;
}
.lst-kix_list_1-6 > li:before {
  content: '' counter(lst-ctn-kix_list_1-6, decimal) ') ';
}
.lst-kix_list_2-0 > li:before {
  content: '' counter(lst-ctn-kix_list_2-0, decimal) '. ';
}
ol.lst-kix_list_2-1.start {
  counter-reset: lst-ctn-kix_list_2-1 0;
}
.lst-kix_list_4-5 > li {
  counter-increment: lst-ctn-kix_list_4-5;
}
.lst-kix_list_1-8 > li:before {
  content: '' counter(lst-ctn-kix_list_1-8, lower-roman) ') ';
}
.lst-kix_list_2-2 > li:before {
  content: '' counter(lst-ctn-kix_list_2-2, decimal) '. ';
}
ol.lst-kix_list_5-2.start {
  counter-reset: lst-ctn-kix_list_5-2 0;
}
ol {
  margin: 0;
  padding: 0;
}
table td,
table th {
  padding: 0;
}
.c11 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 72pt;
  padding-bottom: 6pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c27 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 36pt;
  padding-bottom: 6pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c8 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 72pt;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c5 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 36pt;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c13 {
  margin-left: 0pt;
  padding-top: 12pt;
  list-style-position: inside;
  text-indent: 72pt;
  padding-bottom: 6pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c0 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 45pt;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c1 {
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 1em;

  font-style: normal;
}
.c24 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 36pt;
  padding-bottom: 12pt;

  text-align: left;
}
.c9 {
  margin-left: 0pt;
  padding-top: 0pt;
  list-style-position: inside;
  text-indent: 36pt;
  padding-bottom: 12pt;

  text-align: justify;
}
.c26 {
  padding-top: 0pt;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
.c29 {
  padding-top: 0pt;
  padding-bottom: 14pt;

  orphans: 2;
  widows: 2;
  text-align: center;
}
.c18 {
  padding-top: 0pt;
  padding-bottom: 0pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
.c30 {
  padding-top: 0pt;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: justify;
}
.c6 {
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;

  font-style: normal;
}
.c15 {
  padding-top: 14pt;
  padding-bottom: 14pt;

  orphans: 2;
  widows: 2;
  text-align: center;
}
.c7 {
  text-decoration: none;
  vertical-align: baseline;

  font-style: normal;
}
.c14 {
  text-decoration-skip-ink: none;
  -webkit-text-decoration-skip: none;
  color: #0000ff;
  text-decoration: underline;
}
.c31 {
  margin-left: 108pt;
  text-indent: 36pt;
  height: 18pt;
}
.c28 {
  margin-left: 0pt;
  list-style-position: inside;
  text-indent: 45pt;
}
.c4 {
  padding: 0;
  margin: 0;
}
.c19 {
  max-width: 468pt;
  padding: 72pt 72pt 72pt 72pt;
}
.c2 {
  font-size: 1em;
}
.c23 {
  height: 12pt;
}
.c25 {
  font-size: 1em;
}
.c22 {
  page-break-after: avoid;
}
.c20 {
  font-weight: 400;
}
.c17 {
}
.c16 {
}
.c3 {
  font-weight: 700;
}
.c21 {
  font-size: 8pt;
}
.title {
  padding-top: 12pt;

  font-weight: 700;
  font-size: 1em;
  padding-bottom: 12pt;

  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: center;
}
.subtitle {
  padding-top: 0pt;

  font-weight: 700;
  font-size: 1em;
  padding-bottom: 12pt;

  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}
li {
  font-size: 1em;
}
p {
  margin: 0;

  font-size: 1em;
}
h1 {
  padding-top: 0pt;

  font-size: 1em;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
h2 {
  padding-top: 0pt;

  font-size: 1em;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
h3 {
  padding-top: 0pt;

  font-size: 1em;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
h4 {
  padding-top: 0pt;

  font-size: 1em;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
h5 {
  padding-top: 0pt;

  font-size: 1em;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
h6 {
  padding-top: 0pt;

  font-size: 1em;
  padding-bottom: 12pt;

  orphans: 2;
  widows: 2;
  text-align: left;
}
</style>
